import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { brand } from "../content/siteContent";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-navy flex items-center justify-center relative overflow-hidden px-6">
      <div className="absolute inset-0 blueprint opacity-50" />
      <div className="relative w-full max-w-lg text-center">
        <XCircle className="h-12 w-12 text-white/60 mx-auto" />
        <h1 className="mt-6 font-display font-extrabold text-white text-2xl lg:text-3xl tracking-tight">
          Payment cancelled.
        </h1>
        <p className="mt-4 text-white/70 text-sm leading-relaxed max-w-md mx-auto">
          No charge was made. Your place is not yet reserved — you can return and complete enrolment
          whenever you're ready, or request the prospectus first.
        </p>
        <Link to="/#enrol" data-testid="cancel-home"
          className="mt-8 inline-flex items-center gap-2 bg-teal text-white font-display font-semibold text-sm rounded-sm px-6 py-3.5 hover:bg-[#08929f] transition-colors">
          Back to enrolment
        </Link>
        <p className="mt-8 font-display font-bold text-gold tracking-[0.25em] uppercase text-xs">{brand.tagline}</p>
      </div>
    </div>
  );
}
